import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import JourneyPage from "./pages/JourneyPage";
import Leadership from "./pages/Leadership";
import PersonProfile from "./pages/PersonProfile";
import GoverningBody from "./pages/GoverningBody";
import GoverningBodyProfile from "./pages/GoverningBodyProfile";
import AdvisoryBoard from "./pages/AdvisoryBoard";
import Services from "./pages/Services";
import InternationalCooperation from "./pages/InternationalCooperation";
import WASMEPartnershipPage from "./pages/WasmePartnershipPage";
import MSMESchemesPage from "./pages/MSMESchemePage";
import WASMENewsletters from "./pages/WASMENewsLetters";
import ICSMEPage from "./pages/ICSMEPage";
import ContactPage from "./pages/ContactPage";
import UpcomingEventsPage from "./pages/UpcomingEventsPage";
import EventReportsPage from "./pages/EventsReportPage";
import MembershipPage from "./pages/MembershipPage";
import MembershipForm from "./pages/MembershipForm";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/journey" element={<JourneyPage />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/leadership/:id" element={<PersonProfile />} />
        <Route path="/governing-body" element={<GoverningBody />} />
        <Route path="/governing-body/:id" element={<GoverningBodyProfile />} />
        <Route path="/advisory" element={<AdvisoryBoard/>}/>
        <Route path="/services" element={<Services />} />
        <Route path="/internationalCooperation"element={<InternationalCooperation/>}/>
        <Route path="/partnership" element={<WASMEPartnershipPage/>}/>
        <Route path="/msmeSchemes" element={<MSMESchemesPage/>}/>
        <Route path="/newsletter" element={<WASMENewsletters/>}/>
        <Route path="icsme" element={<ICSMEPage/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/upcomingEvents" element={<UpcomingEventsPage/>}/>
        <Route path="/reports" element={<EventReportsPage/>}/>
        <Route path="/membership" element={<MembershipPage/>}/>
        <Route path="/membershipForm" element={<MembershipForm/>}/>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;